import React from 'react';
import { useSelector } from 'react-redux';
import { SURVEY_SUBMITTED } from '../redux/actions/chatAction';
import { getAgentStatus, getChatState } from '../redux/reducers/app';

// const UnavailablePage = (msg) => {
//     return (
//         <div className='no-available'>
//             <img 
//                 style={{ width: 50, height: 50 }}
//                 src={require('../c2c/assets/agent.png')} 
//             />
//             <div style={{ margin: '40px 0' }}>Nice to meet you!</div>
//             {/* <div>We are here to help.</div>
//             <div>9am-5pm PST Monday-Friday</div> */}
//             <div>{msg}</div>
//         </div>
//     );
// }

var thanktext =(msg,image) =>{
    return (
        <div className='no-available'>
            <img 
                style={{ width: 50, height: 50, opacity: 0.5 }}
                // src={require('../c2c/unauth/assets/agent.png')} 
                src={image} 
                alt=''
            />
            <div style={{ margin: '40px 0' }}>Nice to meet you!</div>
            {/* <div>We are here to help.</div> */}
            {/* <div>9am-5pm PST Monday-Friday</div> */}
            <div className='no-available-msg'>{msg}</div>
        </div>
    );
}

const ThankPage = (props) => {
    const { 
		appConfig
	} = props;
    const chatState = useSelector(state => getChatState(state));
    const agentStatus = useSelector(state => getAgentStatus(state));
    let message = '';
    if(chatState === SURVEY_SUBMITTED) {
        message = 'Thank you for chatting with CIBC FirstCaribbean. We thank you for your feedback.';
        return (
            <div className='thankyou'>
                {message}
            </div>
        );
    }else if(agentStatus.status === 'unavailable') {
        if(agentStatus.message !== undefined && agentStatus.message !== ''){
            message = agentStatus.message;
        }else {
            message = 'Sorry, there is no available agent at the moment.';
        }
        return thanktext(message,appConfig.notavilimage);
        // return <UnavailablePage msg={message}/>;
    }else if(agentStatus.time !== 0) {
        message = `An agent will join in ${agentStatus.time} mins`;
    }

    return (
        <div className='thankyou'>
            {message}
        </div>
    );
}

export default ThankPage;